// Writing to `state` IS the mutation contract, so the rule cannot be satisfied here — the repo
// disables it globally in .eslintrc.js, and only the pre-commit strict pass for newly ADDED files
// turns it back on. Every sibling mutations module does the same thing and differs only in age.
/* eslint-disable no-param-reassign */
const setEditSelectedSlideIsMine = (state, payload) => {
  state.editSelectedSlideIsMine = payload
}

export default {
  setEditSelectedSlideIsMine,
}
